/* eslint-disable jsx-a11y/label-has-for */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
    Abstrap,
    Icon,
    Row,
    FormInput,
    FormLabel,
} from '../../..';

const propTypes = {
    ...Abstrap.propTypes,
    name: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    resetable: PropTypes.bool,
    emptyContent: PropTypes.any,
    withPreview: PropTypes.bool,
    value: PropTypes.any,
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: Fragment,
    resetable: true,
    emptyContent: 'Glissez & déposez ici',
    fileName: '',
    withPreview: false,
    value: '',
};

class FormInputFile extends Abstrap {

    constructor(props) {
        super(props);
        this.dragEnter = this.dragEnter.bind(this);
        this.dragLeave = this.dragLeave.bind(this);
        this.state = {
            hovered: false,
            valueSrc: this.props.value,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.value === prevProps.value) {
            return;
        }
        if (!this.props.value && this.state.valueSrc) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                valueSrc: null,
            });
        }
        if (typeof this.props.value === 'object') {
            const reader = new FileReader();
            reader.readAsDataURL(this.props.value);
            reader.onload = (e) => {
                this.setState({
                    valueSrc: e.target.result,
                });
            };
        } else if (typeof this.props.value === 'string') {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                valueSrc: this.props.value,
            });
        }
    }

    dragEnter() {
        this.setState({
            hovered: true,
        });
    }

    dragLeave() {
        this.setState({
            hovered: false,
        });
    }

    renderPreview() {
        const {
            value,
            withPreview,
        } = this.props;
        const { hovered } = this.state;
        const { valueSrc } = this.state;
        if (hovered) {
            return (
                <Row noCol hcenter vcenter style={{ width: '100%', height: '100%' }}>
                    <img src="/images/file-import.svg" alt="Drag and drop hover" />
                </Row>
            );
        }
        if (!value || !withPreview) {
            return null;
        }
        return (
            <img
                src={valueSrc}
                className="c-form__fileupload_preview"
                alt="Input file preview"
            />
        );
    }

    renderContent() {
        const {
            emptyContent,
            fileName,
            resetable,
            onReset,
            value,
        } = this.props;
        const { hovered } = this.state;
        if (hovered) {
            return null;
        }
        if (!value) {
            return (
                <span className="c-form__fileupload_info">
                    {emptyContent}
                </span>
            );
        } if (!resetable) {
            return (
                <>
                    <span className="c-form__fileupload_filename">
                        {fileName}
                    </span>
                    <span className="c-form__fileupload_reset" style={{ zIndex: 0 }}>
                        <Icon icon="pencil" onClick={onReset} />
                    </span>
                </>
            );
        }
        return (
            <>
                <span className="c-form__fileupload_filename">
                    {fileName}
                </span>
                <span className="c-form__fileupload_reset">
                    <Icon icon="times" onClick={onReset} />
                </span>
            </>
        );
    }

    render() {
        const { name } = this.props;
        const { hovered } = this.state;
        return (
            <>
                <FormInput
                    type="file"
                    autoComplete="off"
                    onDragEnter={this.dragEnter}
                    onDragOver={this.dragEnter}
                    onDragLeave={this.dragLeave}
                    onDragEnd={this.dragLeave}
                    onDrop={this.dragLeave}
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.filterProps()}
                />
                <FormLabel
                    htmlFor={name}
                    className={hovered ? 'c-form__label_hovered' : null}
                >
                    {this.renderPreview()}
                    {this.renderContent()}
                </FormLabel>
            </>
        );
    }

}

FormInputFile.propTypes = propTypes;

FormInputFile.defaultProps = defaultProps;

export default FormInputFile;
